import { ACTIONS } from "../../common/constants";

const scmCatalogFiltersReducer = function (
  state = { pageNo: 0, filter: {} },
  action
) {
  switch (action.type) {
    case ACTIONS.SET_SCM_CATALOG_FILTERS:
      return action.data;
    default:
      return state;
  }
};

export default scmCatalogFiltersReducer;
